var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"modal-is-open":_vm.modalIsOpen,"modal-title":_vm.modalTitle,"button-text":_vm.buttonText},on:{"on-close":function($event){return _vm.$emit('on-close')}}},[_c('p',[_vm._v(_vm._s(_vm.modalText))])])}
var staticRenderFns = []

export { render, staticRenderFns }